<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div v-if="modal_active" class="col-xl-12 order-xl-1" style="text-align: center;">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-0">{{$t('please_confirm_email')}}</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{$t('please_check_email_and_click')}}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-center">
                                    <base-button @click="SendEmailConfirm()" type="primary">{{$t('send_again')}}</base-button>
                                    <base-button @click="goLogout()" type="danger">{{$t('logout')}}</base-button>
                                </div>

                        </template>
                    </card>
                </div>
                <div v-if="modal_renew" class="col-xl-12 order-xl-1" style="text-align: center;">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-0">{{$t('please_renew')}}</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{$t('profile_expired')}}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-center">
                                    <base-button @click="Renew()" type="primary">{{$t('renew')}}</base-button>
                                    <base-button @click="goLogout()" type="danger">{{$t('logout')}}</base-button>
                                </div>

                        </template>
                    </card>
                </div>
                <div v-if="modal_disabled" class="col-xl-12 order-xl-1" style="text-align: center;">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-0">{{$t('profile_disabled')}}</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{$t('please_contact')}}
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <div class="text-center">
                                    <base-button @click="goLogout()" type="danger">{{$t('logout')}}</base-button>
                                </div>

                        </template>
                    </card>
                </div>
            </div>
        </div>
        

        <modal :show.sync="modal_send_email">

            <p>{{$t('please_check_email')}}</p>

            <template slot="footer">
                <base-button @click="modal_send_email = false" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal_renew_success">

            <p>{{$t('confirm_success')}}</p>

            <template slot="footer">
                <base-button @click="modal_renew_success = false,goHome()" type="primary">{{$t('close')}}</base-button>
            </template>

        </modal>

        <modal :show.sync="modal"
               :gradient="modal_setting.gradient"
               modal-classes="modal-danger modal-dialog-centered">
            <div class="py-3 text-center">
                <i class="ni ni-bell-55 ni-3x"></i>
                <h4 class="heading mt-4"></h4>
                <p>{{modal_setting.alert_text}}</p>
            </div>

            <template slot="footer">
                <base-button type="link"
                             text-color="white"
                             class="ml-auto"
                             @click="modal = false">
                    {{$t('close')}}
                </base-button>
            </template>
        </modal>
    </div>
</template>
<script>
  import i18n from "@/i18n"

  export default {
    components: {
    },
    data() {
      return {
        modal: false,
        modal_setting: {
            alert_text: '',
            gradient: ''
        },
        modal_active: false,
        modal_renew: false,
        modal_disabled: false,
        modal_send_email: false,
        modal_renew_success: false
      };
    },
    created () {
        this.getProfile()
    },
    methods: {
      getProfile () {
            this.$http.get('profile')
                .then(request => this.getProfileSuccessful(request))
                .catch(() => this.getProfileFailed())
        },
        getProfileSuccessful (req) {
            if (req.data.code !== '0') {
                this.getProfileFailed(req)
                return
            }
            this.$store.commit('addprofile', req.data.data)
            this.checkActive()
        },
        getProfileFailed (req) {
            this.$store.commit('addtoken', '')
            this.$store.commit('addprofile', '')
            this.$store.commit('addgyms', '')
            this.modalAlert(req)
        },
      checkActive () {
        if(this.$store.state.profile.status === 'new') {
          this.modal_active = true
        }
        if(this.$store.state.profile.status === 'disabled') {
          this.modal_disabled = true
        }
        if(this.$store.state.profile.status === 'expired') {
          this.modal_renew = true
        }
        if(this.$store.state.profile.status === 'active') {
          this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
        }
      },
      modalAlert (req) {
            if(req) {
                this.modal_setting.alert_text = req.data.message
            } else {
                this.modal_setting.alert_text = "ERROR"
            }
            this.modal_setting.gradient = "danger"
            this.modal = true
        },
        goLogout () {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/logout')
        },
        goHome () {
            this.$router.replace(this.$route.query.redirect || '/'+i18n.locale+'/dashboard')
        },
        SendEmailConfirm () {
            this.$http.post('profile/resendEmail')
                .then(request => this.SendEmailConfirmSuccessful(request))
                .catch(() => this.SendEmailConfirmFailed())
        },
        SendEmailConfirmSuccessful (req) {
            if (req.data.code !== '0') {
                this.SendEmailConfirmFailed(req)
                return
            }
            this.modal_send_email = true
        },
        SendEmailConfirmFailed (req) {
            this.modalAlert(req)
        },
        Renew () {
            this.$http.post('profile/renew')
                .then(request => this.RenewSuccessful(request))
                .catch(() => this.RenewFailed())
        },
        RenewSuccessful (req) {
            if (req.data.code !== '0') {
                this.RenewFailed(req)
                return
            }
            this.modal_renew_success = true
        },
        RenewFailed (req) {
            this.modalAlert(req)
        },
    }
  };
</script>
<style lang="scss">
</style>
